<!--
  ~ Copyright (C) 2018 Robert Bosch GmbH Copyright (C) 2018 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
  -->

<div
  class="bci-header-container"
  fxLayout="row"
  fxLayoutAlign="space-between center"
>
  <ng-container *ngIf="header?.length">
    <div class="header-title">{{ header }}</div>
  </ng-container>
  <div class="header-content">
    <bci-breadcrumbs fxHide.mobile role="navigation" aria-label="breadcrumbs">
      <ng-container>
        <mat-icon
          fontSet="bosch"
          fontIcon="Bosch-Ic-arrow-expand-right"
          class="breadcrumb-separator"
          style="margin: 0px 10px"
        ></mat-icon>
      </ng-container>
    </bci-breadcrumbs>
    <ng-content></ng-content>
  </div>
  <a class="header-logo" (click)="onLogoClicked()">
    <img
      src="./assets/img/bosch-logo-only.png"
      alt="{{ layoutIntl.inventedLogoAlt }}"
    />
  </a>
</div>
